import React, { Dispatch, SetStateAction} from 'react';
import { Button, ButtonGroup, Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPercentage, faSortAlphaDownAlt, faSortAlphaDown, faSortNumericDownAlt, faSortNumericDown } from '@fortawesome/free-solid-svg-icons';
import { IProduct } from './Product';

interface Props {
  method: Method,
  order: Order,
  setMethod: Dispatch<SetStateAction<Method>>,
  setOrder: Dispatch<SetStateAction<Order>>,
}

export enum Method {
  Discount = "discount",
  Name = "name",
  Price = "price"
}

export enum Order {
  Down,
  Up
}

const methodLabels = {
  [Method.Discount]: "Korting",
  [Method.Name]: "Naam",
  [Method.Price]: "Prijs"
};

const orderIcons = {
  [Method.Discount]: faPercentage,
  [Method.Name]: {
    [Order.Down]: faSortAlphaDownAlt,
    [Order.Up]: faSortAlphaDown
  },
  [Method.Price]: {
    [Order.Down]: faSortNumericDownAlt,
    [Order.Up]: faSortNumericDown
  }
};

export const sortByDiscount = (a: IProduct, b: IProduct) => {
  const discount = {
    a: a.vanprijs / a.prijs,
    b: b.vanprijs / b.prijs
  };
  return discount.a > discount.b ? -1 : discount.a < discount.b ? 1 : 0;
};

export const sortByName = (a: IProduct, b: IProduct) => {
  const name = {
    a: a.name.toUpperCase(),
    b: b.name.toUpperCase()
  };
  return name.a < name.b ? -1 : name.a > name.b ? 1 : 0;
};

export const sortByPrice = (a: IProduct, b: IProduct) => {
  return a.prijs < b.prijs ? -1 : a.prijs > b.prijs ? 1 : 0;
};

const SortDropdown = (props: Props) => {

  const toggleOrder = () => {
    props.setOrder(Order.Down === props.order ? Order.Up : Order.Down);
  }

  const handleOrderClick = () => {
    if (Method.Discount === props.method) return;
    toggleOrder();
  }

  const handleMethodClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const clicked = (event.target as HTMLAnchorElement).dataset.method as Method;
    if (clicked === props.method) return;
    props.setMethod(clicked);
  };

  const sortIcon = Method.Discount === props.method ? orderIcons[props.method] : orderIcons[props.method][props.order];

  return(
    <Dropdown alignRight as={ButtonGroup}>
      <Button size="sm" variant="light" onClick={handleOrderClick}><FontAwesomeIcon icon={sortIcon} className="mr-2"/>{methodLabels[props.method]}</Button>
      <Dropdown.Toggle size="sm" split variant="light" id="dropdown-split-basic" />
      <Dropdown.Menu onClick={handleMethodClick}>
        <Dropdown.Header>Sorteer op</Dropdown.Header>
        {
          Object
            .entries(methodLabels)
            .map(methodLabel => 
              <Dropdown.Item key={methodLabel[0]} data-method={methodLabel[0]} active={methodLabel[0]===props.method}>
                {methodLabel[1]}
              </Dropdown.Item>
            )
        }
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default SortDropdown;